module.exports = "<div>\n  <transfer-domain\n    :modal=\"modal\"\n    :current-site=\"currentSite\"\n    @recheck-domains-nested=\"recheckDomainsNested\"\n    @toggle-modal=\"closeModal\">\n  </transfer-domain>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/admin/websites/edit-site/domains/add-domain/owned/template.html
// module id = otzB
// module chunks = 0